

































import { SheetRequest, Sheet } from '@/model/Sheet';
import CreateSheetForm from '@/components/sheet/CreateSheetForm.vue';
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { ApiError } from '@/model/ApiError';
import ConfirmationModal from '@/components/modal/ConfirmationModal.vue';

@Component({
    components: {
        CreateSheetForm,
        ConfirmationModal,
    },
    computed: {
        ...mapGetters({
            error: 'sheetStorage/getError',
        }),
    },
    methods: {
        ...mapMutations({
            setError: 'sheetStorage/setError',
        }),
        ...mapActions({
            create: 'sheetStorage/create',
            update: 'sheetStorage/updateName',
        }),
    },
})
export default class SheetModal extends Vue {
    @Prop() sheet!: Sheet;

    setError!: (error: ApiError | null) => void;

    loading = false;

    create!: (request: SheetRequest) => Promise<void>;

    update!: (request: SheetRequest) => Promise<void>;

    eventId: number = +this.$route.params.id;

    newItem: Sheet | null = null;

    @Emit()
    success(isUpdate: boolean): boolean {
        return isUpdate;
    }

    onUpdate(): void {
        this.$bvModal.hide('update-name-modal');

        if (this.newItem) {
            this.loading = true;

            this.update({ sheet: this.newItem, eventId: this.eventId })
                .then(() => {
                    this.success(true);
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    }

    onSubmit(item: Sheet): void {
        if (item.id) {
            this.newItem = item;
            this.$bvModal.show('update-name-modal');
        } else {
            this.loading = true;
            this.create({ sheet: item, eventId: this.eventId })
                .then(() => {
                    this.success(false);
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    }

    destroyed(): void {
        this.setError(null);
    }
}
